import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TabletIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tablet"}/>
}
